var countdown = {

    elm : null,
    i : null,

    init: () => {

        countdown.elm = helper.element(".countdown", false);
        let seconds = 0;
        if (countdown.elm && countdown.elm.length === undefined) {
            countdown.i = setInterval(function() {
                countdown.calc(seconds);
                countdown.elm.classList.add("show");
                seconds += 1;
            }, 1000);
        }



    },

    calc: (sec) => {

        let todate = new Date("June 5, 2026 10:00:00").getTime();

        let now = new Date(dt).getTime();
        let span = todate - now - (sec * 1000);

        let days = Math.floor(span / (1000 * 60 * 60 * 24));
        let hours = Math.floor((span % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
        let minutes = Math.floor((span % (1000 * 60 * 60)) / (1000 * 60));
        let seconds = Math.floor((span % (1000 * 60)) / 1000);

        if (span < 0) {
            clearInterval(countdown.i);
            days = 0;
            hours = 0;
            minutes = 0;
            seconds = 0;
        }

        let elmdays = helper.element(".js-day");
        let elmhours = helper.element(".js-hour");
        let elmminutes = helper.element(".js-minute");
        let elmseconds = helper.element(".js-second");

        if (elmdays && elmhours && elmminutes && elmseconds) {
            elmdays.innerText = days.toString().padStart(2, "0");
            elmhours.innerText = hours.toString().padStart(2, "0");
            elmminutes.innerText = minutes.toString().padStart(2, "0");
            elmseconds.innerText = seconds.toString().padStart(2, "0");
        }

    }
};
